<template>
<div>
	<wrapper-edit
      :wrapper-width="wrapperWidth"
      @back="paasPageBack">
    <Form ref="paasForm" slot="form"
            :model="paasFormData"
            :rules="paasFormRules"
            :label-width="defaultLabelWidth">
       <Row>
       <FormItem label="快递公司全称：" prop="name" class="ivu-col-span-24" >
		<Input v-model="paasFormData.name" 
		            clearable ></Input>
		
	   </FormItem>
       </Row>
       <Row>
       <FormItem label="快递公司简称：" prop="code" class="ivu-col-span-24" >
		<Input v-model="paasFormData.code" 
		            clearable  placeholder="快递100对快递公司的编码，例：zhongtong"></Input>
		
	   </FormItem>
       </Row>
      <Row>
        <FormItem label="MC快递编码：" prop="code" class="ivu-col-span-24" >
          <Input v-model="paasFormData.nyseCode"
                 clearable placeholder="对接宝塔系统的快递编码，例：ZTO"></Input>

        </FormItem>
      </Row>
       <Row>
       <FormItem label="排序：" prop="sort" class="ivu-col-span-24" >
		<Input v-model="paasFormData.sort" 
		            clearable ></Input>
		
	   </FormItem>
       </Row>
       <Row>
       <FormItem label="是否显示：" prop="isShow" class="ivu-col-span-24" >
		    <Enum :enumJsonKey="'crmdict-yesOrNo'"  v-model="paasFormData.isShow"  type="radio" ></Enum>
	   </FormItem>
       </Row>
       <div class="edit-oper-toolbar">
	      <Button type="primary" @click="paasFormSubmit('paasForm','','add')">保存并继续添加</Button>
	      <Button @click="paasFormSubmit('paasForm','','expressList')" style="margin-left: 8px">保存并返回</Button>
	      <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
	    </div>  
    </Form>  
      
    </wrapper-edit>
</div>
</template>
<script>
import wrapperEdit from "@components/paas/wrapper-edit";
import metaEdit from "@assets/js/meta-edit.js";
import Enum from '@components/paas/enum-form' //枚举渲染
 
export default {
   name: "edit",
   mixins:[metaEdit],
   components:{wrapperEdit,Enum},
   data(){
     return {
        serviceUrl:"/eb/express",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        paasFormData:{
          id:'',
          name:'',
          code:'',
          nyseCode:'',
          isShow:'',
          sort:'',
        },
        paasFormRules:{
        },
        redirectName:"expressList",
        nextAddName:"expressEdit",
        defaultLabelWidth:120
     }
   },
   methods:{
      }
}
</script>
